import { EUserRole } from "../types/enums";

export const OPERATIONAL_ROLES: EUserRole[] = [
  EUserRole.ADMIN,
  EUserRole.SUPPORT,
  EUserRole.OWNER,
];

export const GLOBAL_ROLES: EUserRole[] = [EUserRole.ADMIN, EUserRole.SUPPORT];

export const ADMIN_ROLES: EUserRole[] = [EUserRole.ADMIN];
